export function addCustomerAccount()
{
    return({
        type:"ADD_CUSTOMER_ACCOUNT"
    })
}